export default __webpack_public_path__ + "static/media/question-cog.46421a6c.svg";